import { useRef } from 'react';
import useOutsideElement from 'components/Dashboard/utilities/useOutsideElement';

const MoreActionsMenu = ({ editor, onClose, onInsertContent, salutation, signature }) => {
  const menuRef = useRef(null);
  useOutsideElement(menuRef, onClose);

  const parent = editor?.editorContainer?.parentElement;
  const buttons = parent?.querySelectorAll('.tox-tbtn');
  const moreActionsBtn = Array.from(buttons || []).find(
    (button) => button.getAttribute('data-mce-name') === 'moreactionsbtn'
  );
  const { top, left } = moreActionsBtn?.getBoundingClientRect() ?? {};

  const style = {
    top: `${(top ?? 0) - 8}px`,
    left: `${left ?? 0}px`,
    right: 'auto',
    transform: 'translateY(-100%)',
  };

  return (
    <>
      <div className='general-close-background z-max' onClick={onClose} />
      <div
        ref={menuRef}
        className='box box-shadow crm-actions-box specific-top-padding-6 specific-bottom-padding-6 z-max position-absolute w-auto'
        style={style}
      >
        <div className='share-container position-relative'>
          <div className='share-container-items flex-column'>
            <button
              onClick={onInsertContent}
              className='general-button specific-right-padding-35 specific-left-padding-16 d-flex align-items-center list-action-button'
            >
              <img
                src={`${import.meta.env.VITE_APP_CDNURL}/images/EditorIcons/insert_content.png`}
                alt=''
                width={18}
                height={18}
              />
              <span className='specific-left-padding-14'>Insert content</span>
            </button>
            {salutation && (
              <button
                onClick={salutation.onClick}
                className='general-button specific-right-padding-35 specific-left-padding-16 d-flex align-items-center list-action-button'
              >
                <span
                  className='d-flex align-items-center justify-content-center font-weight-bold'
                  style={{ width: 18, height: 18, color: '#0094cc' }}
                >
                  @
                </span>
                <span className='specific-left-padding-14'>Use attributes</span>
              </button>
            )}
            {signature && (
              <button
                onClick={signature.disabled ? undefined : signature.onClick}
                disabled={signature.disabled}
                data-tooltip-content={signature.disabled ? signature.tooltip : undefined}
                data-tooltip-id='general-tooltip'
                data-tooltip-place='top'
                className={`general-button specific-right-padding-35 specific-left-padding-16 d-flex align-items-center list-action-button ${
                  signature.disabled ? 'opacity-5' : ''
                }`}
              >
                <img
                  src={`${import.meta.env.VITE_APP_CDNURL}/images/EditorIcons/signature_icon.png`}
                  alt=''
                  width={18}
                  height={18}
                />
                <span className='specific-left-padding-14'>{signature.label}</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MoreActionsMenu;
